import { CUSTOMER_CURRENCY_CODE_RECEIVED } from '../actions/constants/ActionTypes';
const initialState = null;
const CustomerCurrencyCode = (state = initialState, {
  type,
  payload
}) => {
  switch (type) {
    case CUSTOMER_CURRENCY_CODE_RECEIVED:
      return payload;
    default:
      return state;
  }
};
export default CustomerCurrencyCode;